import { SITE, BUSINESS, CATEGORY, SUBCATEGORY, RANGE, PRODUCT, indexDBBreadcrumbs, isIndexDBEnabled } from '@pes-ui/utils';
export const getProductInfoFromBreadcrumbs = (breadcrumbs) => {
  let productCategory = '';
  let productSubCategory = '';
  let productRange = '';
  let productName = '';
  const getProductName = (breadcrumb) => {
    switch (breadcrumb.itemType) {
      case RANGE:
      case PRODUCT:
        return breadcrumb.nameForChat;
      default:
        return breadcrumb.name;
    }
  };
  breadcrumbs.forEach((breadcrumb) => {
    switch (breadcrumb.itemType) {
      case CATEGORY:
        productCategory = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case SUBCATEGORY:
        productSubCategory = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case RANGE:
        productRange = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case PRODUCT:
        productName = getProductName(breadcrumb);
        break;
      default:
        break;
    }
  });
  return {
    productCategory,
    productSubCategory,
    productRange,
    productName,
  };
};
export const getFilteredBreadcrumbs = (breadcrumbs, breadcrumbItemTypes = [SITE, BUSINESS]) => breadcrumbs.filter((breadcrumb) => {
  return !breadcrumbItemTypes.includes(breadcrumb.itemType);
});
export const storeBreadcrumbs = async ({ id, name, url, subcategory, breadcrumbs, storageName, pageName, }) => {
  try {
    await indexDBBreadcrumbs.handleSaveInIndexDB(Object.assign({ targetName: name, targetId: id, targetUrl: url, pageName, baseBreadCrumbs: breadcrumbs, storageName }, (subcategory ? { parentSubCategory: {
        id: subcategory.id,
        itemType: SUBCATEGORY,
        name: subcategory.name,
        nameForChat: '',
        url: subcategory.url,
      } } : {})));
  }
  catch (e) {
    console.error(`[PES]: ${pageName} breadcrumbs for ${id} could not be saved in indexDB`, e);
  }
};
export const storeOnClick = async (e, data) => {
  if (!isIndexDBEnabled()) {
    return;
  }
  e.preventDefault();
  await storeBreadcrumbs(data);
};
export const passBreadcrumbsParams = (storeBreadcrumbsParams) => {
  return (event) => storeOnClick(event, storeBreadcrumbsParams);
};
